<template>
  <v-icon
    class="archive"
    style="color: orange; font-size: 22px !important"
    small
    @click.stop="archiveItem()"
  >
    mdi-archive-arrow-up
  </v-icon>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    id: { type: [String, Number], required: true },
    name: { type: String, required: true },
    body: { type: Object, default: () => ({}) },
    idInBody: { type: Boolean, default: false }, // false = id in URL param, true = id in form-data
  },
  methods: {
    // ===== Archive
    archiveItem() {
      // Start:: Sweet Alert Modal
      this.$swal({
        title: this.$t("areYouSure"),
        // text: this.$t("youWillNotBeAbleToGoBackInTheProcess"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("ok"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.archiveItemConfirm();
        }
      });
      // End:: Sweet Alert Modal
    },
    async archiveItemConfirm() {
      // Start:: Build FormData
      const formData = new FormData();
      if (this.body && typeof this.body === "object") {
        Object.entries(this.body).forEach(([key, value]) => {
          formData.append(key, value);
        });
      }
      if (this.idInBody) {
        formData.append("id", this.id);
      }
      // End:: Build FormData

      // Start:: Build URL
      const url = this.idInBody
        ? `${this.name}`
        : `${this.name}/${this.id}/archived`;
      // End:: Build URL

      await this.axios({
        method: "POST",
        url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(() => {
          // Refresh table data
          let items = this.items.filter((item) => item.id != this.id);
          this.$emit("refresh", items);
          // Refresh table data

          this.$swal({
            title: this.$t("archivedSuccessfully"),
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: this.$t("ok"),
          });
        })
        .catch((err) => {
          let message = "";
          err.response?.data.message
            ? (message = err.response.data.message)
            : (message = err.response.data.messages);
          this.$swal({
            title: message,
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: this.$t("cancel"),
          });
        });
    },
  },
};
</script>

<style>
.archive {
  color: #f59e0b !important;
  transition: color 0.2s ease;
}
.archive:hover {
  color: #d97706 !important; /* darker shade on hover */
}
</style>
